import { HTTPClient } from '@abaco/web-common/src/HTTP';
import { QuestionnaireFilters, QuestionnaireObject, QuestionnaireScores, QuestionnaireScoresAverages } from "../models";

export default class EarthwormApi {
    private http: HTTPClient;

    constructor(http: HTTPClient) {
        this.http = http;
    }

    public async getEducationalQuestionnaires(filters?: QuestionnaireFilters): Promise<QuestionnaireObject[]>
    {
        const options = filters ? { params: filters } : undefined

        // /earthworm/api/v1/questionnaires/incomes

        const res = await this.http.get('/earthworm/api/v1/questionnaires/educational-levels', options)

        return res.data
    }

    public async getIncomesQuestionnaires(filters?: QuestionnaireFilters): Promise<QuestionnaireObject[]>
    {
        const options = filters ? { params: filters } : undefined

        // /earthworm/api/v1/questionnaires/incomes

        const res = await this.http.get('/earthworm/api/v1/questionnaires/incomes', options)

        return res.data
    }

    public async getQuestionnairesLookup(val: string): Promise<QuestionnaireObject[]>
    {
        ///earthworm/api/v1/questionnaires/checklist/

        const res = await this.http.get('/earthworm/api/v1/questionnaires/checklist/' + val)

        return res.data
    }

    public async getQuestionnairesScores(): Promise<QuestionnaireScores[]>
    {
        const res = await this.http.get('/earthworm/api/v1/scores')

        return res.data
    }

    public async getQuestionnairesAverages(): Promise<QuestionnaireScoresAverages>
    {
        const res = await this.http.get('/earthworm/api/v1/scores/average')

        return res.data
    }
}
